import { Card } from 'mga-commons';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { anonymousLastSubscribedGetItems, selectItems } from '../../../../slices/anonymous/anonymousStatSlice';
import './CardRecemmentInscrit.css';

const renderItems = (items) => {

    if (!items) {
        return null
    }

    return items.map(function (item, index) {
        return (
            <Link to={item.UrlRelatif} key={item.IdFiche} title={item.LibelleAffichage}>
                <Card margin="10px 20px">
                    <div className="item">
                        <img loading="lazy" className="image" src={item.UrlImage}  />
                        <div className="details">
                            <div className="specialite">{item.LibelleTypeEntite}</div>
                            <div className="nom">{item.LibelleAffichage}</div>
                            <div className="wilaya">{item.Wilaya}</div>
                        </div>
                    </div>
                </Card>
            </Link>
        )
    })
}

export const CardRecemmentInscrit = ({ }) => {

    const dispatch = useDispatch()

    const items = useSelector(selectItems)


    useEffect(() => {

        // Load data
        dispatch(anonymousLastSubscribedGetItems())

    }, [])


    return (
        <div className="card-recemment-inscrit">
            {renderItems(items)}
        </div>
    )
}

export default CardRecemmentInscrit
